import * as backendMembers from '../../utils/ApiRest/backendMembers'
import * as actionsTypesMembers from '../actionsTypesMembers'

function beneficiairesRequest(isLoading) {
  return {
    type: actionsTypesMembers.BENEFICIAIRE_REQUEST,
    isLoading,
  }
}
function beneficiairesFailure(isError) {
  return {
    type: actionsTypesMembers.BENEFICIAIRE_FAILURE,
    isError,
  }
}
function beneficiairesSuccess(isSuccess, beneficiairesData) {
  return {
    type: actionsTypesMembers.BENEFICIAIRE_SUCCESS,
    isSuccess,
    beneficiairesData,
  }
}
export function fetchBeneficiairesAction(souscripteurID) {
  return function(dispatch, getState) {

    dispatch(beneficiairesRequest(true))

    return backendMembers.getAllBeneficiaire(souscripteurID)
      .then(beneficiairesData => {
        dispatch(beneficiairesRequest(false))
        dispatch(beneficiairesSuccess(true, beneficiairesData))
      })
      .catch(error => {
        dispatch(beneficiairesRequest(false))
        dispatch(beneficiairesFailure(true))
      })
  }
}

function addBeneficiaireRequest(isLoading) {
  return {
    type: actionsTypesMembers.ADD_BENEFICIAIRE_REQUEST,
    isLoading,
  }
}
function addBeneficiaireFailure(isError) {
  return {
    type: actionsTypesMembers.ADD_BENEFICIAIRE_FAILURE,
    isError,
  }
}
function addBeneficiaireSuccess(isSuccess) {
  return {
    type: actionsTypesMembers.ADD_BENEFICIAIRE_SUCCESS,
    isSuccess,
  }
}
export function fetchAddBeneficiaireAction(souscripteurID, beneficiaireData) {
  return function(dispatch, getState) {

    dispatch(addBeneficiaireRequest(true))

    return backendMembers.saveBeneficiaire(souscripteurID, beneficiaireData)
      .then(response => {
        dispatch(addBeneficiaireRequest(false))
        dispatch(addBeneficiaireSuccess(true))
      })
      .catch(error => {
        dispatch(addBeneficiaireRequest(false))
        dispatch(addBeneficiaireFailure(true))
      })
  }
}

function updateBeneficiaireRequest(isLoading) {
  return {
    type: actionsTypesMembers.UPDATE_BENEFICIAIRE_REQUEST,
    isLoading,
  }
}
function updateBeneficiaireFailure(isError) {
  return {
    type: actionsTypesMembers.UPDATE_BENEFICIAIRE_FAILURE,
    isError,
  }
}
function updateBeneficiaireSuccess(isSuccess) {
  return {
    type: actionsTypesMembers.UPDATE_BENEFICIAIRE_SUCCESS,
    isSuccess,
  }
}
export function fetchUpdateBeneficiaireAction(beneficiaireID, beneficiaireData) {
  return function(dispatch, getState) {

    dispatch(updateBeneficiaireRequest(true))

    return backendMembers.updateBeneficiaire(beneficiaireID, beneficiaireData)
      .then(response => {
        dispatch(updateBeneficiaireRequest(false))
        dispatch(updateBeneficiaireSuccess(true))
      })
      .catch(error => {
        dispatch(updateBeneficiaireRequest(false))
        dispatch(updateBeneficiaireFailure(true))
      })
  }
}

function removeBeneficiaireRequest(isLoading) {
  return {
    type: actionsTypesMembers.REMOVE_BENEFICIAIRE_REQUEST,
    isLoading,
  }
}
function removeBeneficiaireFailure(isError) {
  return {
    type: actionsTypesMembers.REMOVE_BENEFICIAIRE_FAILURE,
    isError,
  }
}
function removeBeneficiaireSuccess(isSuccess) {
  return {
    type: actionsTypesMembers.REMOVE_BENEFICIAIRE_SUCCESS,
    isSuccess,
  }
}
export function fetchRemoveBeneficiaireAction(beneficiaireID) {
  return function(dispatch, getState) {

    dispatch(removeBeneficiaireRequest(true))

    return backendMembers.removeBeneficiaire(beneficiaireID)
      .then(response => {
        dispatch(removeBeneficiaireRequest(false))
        dispatch(removeBeneficiaireSuccess(true))
      })
      .catch(error => {
        dispatch(removeBeneficiaireRequest(false))
        dispatch(removeBeneficiaireFailure(true))
      })
  }
}



// WEBPACK FOOTER //
// ./src/actions/Souscription/Beneficiaire.js